import React from 'react';

import Table from 'components/Table';
import BooleanIcon from 'components/BooleanIcon';
import './styles.css';

const WebhooksTable = ({webhooks}) => (
  <div className="WebhooksTable">
    <header className="header">
      <h3>Webhooks</h3>
    </header>

    <div className="tableContainer">
      <div className="tableHeader">
        <Table>
          <Table.Header>
            <Table.HeaderItem className="id" heading={'id'} />
            <Table.HeaderItem className="name" heading={'name'} />
            <Table.HeaderItem
              className="subscribedEvents"
              heading={'Subscribed events'}
            />
            <Table.HeaderItem className="secret" heading={'secret'} />
            <Table.HeaderItem className="pending" heading={'Pending'} />
            <Table.HeaderItem className="scheduled" heading={'Scheduled'} />
            <Table.HeaderItem className="running" heading={'Running'} />
            <Table.HeaderItem className="succeeded" heading={'Succeeded'} />
            <Table.HeaderItem className="failed" heading={'Failed'} />
            <Table.HeaderItem className="cancelled" heading={'Cancelled'} />
            <Table.HeaderItem
              className="permanentlyFailed"
              heading={'Permanently Failed'}
            />
            <Table.HeaderItem className="enabled" heading={'enabled'} />
          </Table.Header>
        </Table>
      </div>
      <div className="tableBody">
        <Table>
          <Table.Body>
            {webhooks.map(webhook => (
              <Table.Row key={webhook.id}>
                <Table.Cell className="id">{webhook.id}</Table.Cell>
                <Table.Cell className="name">{webhook.name}</Table.Cell>
                <Table.Cell className="subscribedEvents">
                  <div className="content">{webhook.subscribedEventNames}</div>
                </Table.Cell>
                <Table.Cell className="secret">
                  <div className="content">{webhook.secret}</div>
                </Table.Cell>
                <Table.Cell className="pending">
                  {webhook.calls.pending}
                </Table.Cell>
                <Table.Cell className="scheduled">
                  {webhook.calls.scheduled}
                </Table.Cell>
                <Table.Cell className="running">
                  {webhook.calls.running}
                </Table.Cell>
                <Table.Cell className="succeeded">
                  {webhook.calls.succeeded}
                </Table.Cell>
                <Table.Cell className="failed">
                  {webhook.calls.failed}
                </Table.Cell>
                <Table.Cell className="cancelled">
                  {webhook.calls.cancelled}
                </Table.Cell>
                <Table.Cell className="permanentlyFailed">
                  {webhook.calls.permanentlyFailed}
                </Table.Cell>
                <Table.Cell className="enabled">
                  <BooleanIcon
                    value={webhook.enabled}
                    trueAlt={'Enabled'}
                    falseAlt={'Not Enabled'}
                  />
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </div>
    </div>
  </div>
);

export default WebhooksTable;
